import { Modal } from '@seiue/ui'
import { UploadFile } from 'antd/es/upload/interface'

import { ImportModal } from './ImportModal'
import { ActionType } from './types'

export * from './types'

export interface ImportProps {
  /**
   * 点击导出模板时的回调
   */
  onClickDownload: () => void
  /**
   * 导入弹窗标题
   */
  title: string
  /**
   * 导入的目的，是为了创建数据还是更新数据
   */
  action?: ActionType
  /**
   * 处理上传文件的函数
   * @param file 准备导入的文件
   */
  uploadRemote: (file: UploadFile) => Promise<boolean>
  /**
   * 上传之前调用，当返回 == false 时，不会执行下一步（即 uploadRemote）
   * @param file 准备导入的文件
   */
  beforeUpload?: (file: UploadFile) => void | Promise<boolean> | boolean
  /**
   * 最大导入文件大小，单位为 Byte
   *
   * 默认为 10M
   */
  maxUploadFileSize?: number
  onCancel?: () => void

  // 导出提示 - 标题
  tipTitle?: string
  // 导出提示 - 文案
  tip?: string
  // 导出按钮 - 显示文本
  exportBtnText?: string
}

export const importData = (props: ImportProps) => {
  const { title, onCancel } = props
  const { hide } = Modal.open({
    title,
    footer: null,
    width: '640px',
    bodyStyle: {
      padding: '0',
    },
    children: (
      <ImportModal
        {...props}
        onCancel={() => {
          onCancel?.()
          hide()
        }}
      />
    ),
  })
}
